import React, { Component } from 'react';
import { VERSION_NUM, ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isGV = ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || ROOT_URL === 'https://gvyummy-scm.truckxi.com/api/';

class Footer extends Component {

    render() {
        return (
            <footer>
                <div>
                {!isGV && <span style={{float: 'left'}}>&copy; 2019 - Truckxi.com</span>}
                <span style={{float: 'right'}}>v.{VERSION_NUM}</span>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/Footer.jsx